export default __webpack_public_path__ + "static/reservering-bert-jonk-b54623e8664c13e719623412a5959645.webp";